import React from 'react'
import {AbilityContextProvider} from '@modifi/plugin-authorization'
import {AdminDialogLayout} from '@modifi/ui'
import {abilityFactory} from '../../constants/permissions'

const ability = abilityFactory()

export const WrappedAdminDialogLayout = props => (
  <AbilityContextProvider ability={ability}>
    <AdminDialogLayout {...props} />
  </AbilityContextProvider>
)
